import { Card, CardBody } from '@chakra-ui/react'

export const ExportWrapper = ({ children }: { children: React.ReactNode }) => {
  return (
    <Card p={8}>
      <CardBody>
        {children}
      </CardBody>
    </Card>
  )
}
